export default __webpack_public_path__ + "static/media/Globe.59384472.svg";